/**
 * `bindInput` は、指定した setter 関数を
 * `onChange` と `onBlur` の両方にバインドするユーティリティです。
 *
 * これを使うと、input の変更時とフォーカスが外れた時に
 * 同じ setter が呼び出されるようになります。
 *
 * 例：
 * <FormField
 *   value={value}
 *   {...bindInput(setValue)}
 *   ...
 * />
 *
 * @param setter - 入力値を受け取って状態を更新する関数
 * @returns
 *   onChange と onBlur のイベントハンドラをまとめて返します
 */
export function bindInput(setter: (value: string) => void): {
    onChange: React.ChangeEventHandler<HTMLInputElement>;
    onBlur: React.FocusEventHandler<HTMLInputElement>;
} {
    return {
        onChange: (e) => setter(e.currentTarget.value),
        onBlur: (e) => setter(e.currentTarget.value),
    };
}
